import React, { useContext, useRef } from 'react';
import HeaderView from '../../common/HeaderView';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import { Context as VendorContext } from '../../../providers/VendorContextProvider';
import AnalyticsOverviewView from '../analytics/AnalyticsOverviewView';
import { ECOM_REPORT_ENUM } from '../analytics/reportsConfig';
import { vendorAnalyticsAndReportsConfig } from '../analytics/vendorAnalyticsAndReportsConfig';

const VendorAnalyticsView = () => {
  const hasFetched = useRef(false);
  const { state: authState } = useContext(AuthContext);
  const { state, fetchVendorAnalytics, generateVendorReport } = useContext(
    VendorContext
  );
  const reportConfig = vendorAnalyticsAndReportsConfig.reports.find(
    (c) => c.uuid === ECOM_REPORT_ENUM.OVERVIEW
  );

  const loading =
    !hasFetched.current ||
    state.ecomVendorAnalytics.loading ||
    state.ecomVendorReport.loading ||
    reportConfig.uuid !== state.ecomVendorReport.value?.uuid;

  const onFetchAnalyticsOverview = (filter) => {
    const groupByPeriod = reportConfig.groupBy === 'period';
    const compareEnabled = groupByPeriod && reportConfig.compareEnabled;
    generateVendorReport(authState.pkEcomVendor, {
      uuid: reportConfig.uuid,
      headers: reportConfig.defaultHeaders,
      groupBy: reportConfig.groupBy,
      ...filter,
      periodInterval: groupByPeriod ? filter.periodInterval : null,
      compareStartDate: compareEnabled ? filter.compareStartDate : null,
      compareEndDate: compareEnabled ? filter.compareEndDate : null
    });

    fetchVendorAnalytics(authState.pkEcomVendor, filter);
    hasFetched.current = true;
  };

  return (
    <HeaderView noHeader>
      <AnalyticsOverviewView
        analyticConfigs={vendorAnalyticsAndReportsConfig.analytics}
        dataState={state.ecomVendorAnalytics.value}
        entityId={authState.pkEcomVendor}
        loading={loading}
        onFetchOverview={onFetchAnalyticsOverview}
        reportResult={state.ecomVendorReport.value}
        urlBase="/vendor/reports"
      />
    </HeaderView>
  );
};

export default VendorAnalyticsView;
